/** Atributo en el botón de tema (luna/sol) del NavBar — usado por el aviso post-login */
export const WEMBII_DARK_MODE_TOGGLE_ATTR = "data-wembii-dark-mode-toggle";
/** Atributo en el botón de créditos IA — usado por el aviso de pocos créditos */
export const WEMBII_AI_CREDITS_TOGGLE_ATTR = "data-wembii-ai-credits-toggle";
/** Evento global para refrescar saldo de créditos IA en UI */
export const WEMBII_AI_CREDITS_REFRESH_EVENT = "wembii-ai-credits-refresh";
